import React, { memo } from 'react';
import { Home, Store, Bell, User } from 'lucide-react';

const BottomNav = ({ activeTab, onTabChange, onGoHome, role, notificationCount = 0 }) => {
    const isOwner = role === 'owner';

    return (
        <nav className="fixed bottom-0 left-0 right-0 z-50 entrance-glass pb-[max(env(safe-area-inset-bottom),0.5rem)] shadow-[0_-12px_40px_rgba(0,0,0,0.6)] will-change-transform rounded-t-3xl border-t border-white/5">
            <div className="max-w-md mx-auto px-10 h-20 flex items-center justify-between relative">
                {/* Visual Glow Background for center button area */}
                <div className="absolute left-1/2 -translate-x-1/2 top-0 w-32 h-12 bg-orange-500/10 blur-[40px] pointer-events-none" />

                {/* Home / Grid */}
                <button
                    onClick={onGoHome}
                    className={`flex flex-col items-center gap-1.5 transition-all duration-300 ${!activeTab ? 'text-white scale-110' : 'text-slate-400 hover:text-slate-300'
                        }`}
                >
                    <div className={`p-2.5 rounded-2xl transition-all ${!activeTab ? 'bg-white/10 shadow-lg shadow-white/5' : 'hover:bg-white/5'}`}>
                        <Home size={22} strokeWidth={!activeTab ? 2.5 : 2} />
                    </div>
                    <span className="text-[10px] font-bold tracking-tight opacity-80">
                        {isOwner ? 'Tổng quan' : 'Bảng điều khiển'}
                    </span>
                </button>

                {/* POS - Prominent Center Button */}
                <div className="relative -top-8 group">
                    <div className="absolute inset-0 bg-orange-500/20 blur-2xl rounded-full scale-150 group-hover:scale-175 transition-transform duration-500" />
                    <button
                        onClick={() => onTabChange('pos')}
                        className="relative w-20 h-20 bg-gradient-to-br from-orange-400 via-orange-500 to-red-600 rounded-[30px] flex items-center justify-center shadow-[0_12px_40px_rgba(249,115,22,0.4)] active:scale-95 transition-all duration-500 hover:rotate-2 border-2 border-white/20"
                    >
                        <Store className="text-white drop-shadow-lg" size={32} strokeWidth={2.5} />
                    </button>
                    <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 text-[11px] font-black text-white/50 tracking-[0.15em] uppercase whitespace-nowrap group-hover:text-orange-400 transition-colors">POS Portal</span>
                </div>

                {/* Notifications */}
                <button
                    onClick={() => onTabChange('notifications')}
                    className={`flex flex-col items-center gap-1.5 transition-all duration-300 ${activeTab === 'notifications' ? 'text-white scale-110' : 'text-slate-400 hover:text-slate-300'
                        }`}
                >
                    <div className={`p-2.5 rounded-2xl transition-all relative ${activeTab === 'notifications' ? 'bg-white/10 shadow-lg shadow-white/5' : 'hover:bg-white/5'}`}>
                        <Bell size={22} strokeWidth={activeTab === 'notifications' ? 2.5 : 2} />
                        {notificationCount > 0 && (
                            <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-[10px] flex items-center justify-center rounded-full border-2 border-slate-900 font-black shadow-lg">
                                {notificationCount}
                            </span>
                        )}
                    </div>
                    <span className="text-[10px] font-bold tracking-tight opacity-80">Thông báo</span>
                </button>
            </div>
        </nav>
    );
};

export default memo(BottomNav);
